import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgIcon } from '@ng-icons/core';
import { QpxButton, QpxIcon, QpxTooltip } from '../../directives';

@Component({
    selector: 'qpx-content-width-toggle',
    imports: [MatButtonModule, QpxTooltip, NgIcon, QpxButton, QpxIcon],
    templateUrl: './toggle.html',
    styleUrl: './toggle.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'data-qpx-content-width-sensitive': '',
    },
})
export class QpxContentWidthToggle {
    //#region Inputs
    public readonly expanded = input(false);
    public readonly label = input('Content width');
    //#endregion

    //#region Outputs
    public readonly toggleRequested = output<void>();
    //#endregion

    //#region State
    protected readonly icon = computed(() =>
        this.expanded() ? 'lucideMinimize' : 'lucideMaximize'
    );
    //#endregion

    //#region Template methods
    protected onToggleRequested(): void {
        this.toggleRequested.emit();
    }
    //#endregion
}
